import {FC} from "react";
import {CgArrowLeft, CgArrowRight} from "react-icons/cg";

interface Props {
    currentPage: number;
    pages: number;
    onPageSelected: (page: number) => void;
    className?: string;
}

const Pagination: FC<Props> = (props) => {
    return (
        <div className={`flex items-center gap-2 ${props.className}`}>
            {props.currentPage !== 1 && <button className='text-white flex items-center gap-1 bg-secondary px-4 py-2 rounded' onClick={props.onPageSelected.bind(this,props.currentPage-1)}><CgArrowLeft className='text-lg'/><span className='hidden lg:inline'>Vorherige</span></button>}
            {props.currentPage-2 > 0 && <button className='text-white flex items-center gap-1 bg-secondary px-4 py-2 rounded' onClick={props.onPageSelected.bind(this,props.currentPage-2)}>{props.currentPage-2}</button>}
            {props.currentPage-1 > 0 && <button className='text-white flex items-center gap-1 bg-secondary px-4 py-2 rounded' onClick={props.onPageSelected.bind(this,props.currentPage-1)}>{props.currentPage-1}</button>}
            <button className='text-white flex items-center gap-1 bg-secondary/50 px-4 py-2 rounded'>{props.currentPage}</button>
            {props.currentPage+1 <= props.pages && <button className='text-white flex items-center gap-1 bg-secondary px-4 py-2 rounded' onClick={props.onPageSelected.bind(this,props.currentPage+1)}>{props.currentPage+1}</button>}
            {props.currentPage+2 <= props.pages && <button className='text-white flex items-center gap-1 bg-secondary px-4 py-2 rounded' onClick={props.onPageSelected.bind(this,props.currentPage+2)}>{props.currentPage+2}</button>}
            {props.currentPage !== props.pages && <button className='text-white flex items-center gap-1 bg-secondary px-4 py-2 rounded' onClick={props.onPageSelected.bind(this,props.currentPage+1)}><CgArrowRight className='text-lg'/><span className='hidden lg:inline'>Nächste</span></button>}
        </div>
    );
};

export default Pagination;